<template>
  <div class="holder">
    <router-view></router-view>
  </div>
</template>

<script>
  module.exports = {
  };
</script>
